/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Achievements_Flipall2Inputs */

const id_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balik Semua`)
};

const ms_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balik Semua`)
};

const da_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vend Alle`)
};

const de_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle umdrehen`)
};

const en_us2_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flip All`)
};

const es_es2_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltear todo`)
};

const es_mx2_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltear todo`)
};

const fil_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-flip Lahat`)
};

const fr_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout retourner`)
};

const it_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capovolgi tutto`)
};

const hu_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Összes megfordítása`)
};

const nl_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles omdraaien`)
};

const no_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vend alle`)
};

const pl_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odwróć wszystkie`)
};

const pt_br2_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virar tudo`)
};

const pt_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverter tudo`)
};

const ro_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inversează toate`)
};

const fi_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käännä kaikki`)
};

const sv_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vänd alla`)
};

const vi_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lật tất cả`)
};

const tr_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tümünü Çevir`)
};

const cs_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otočit vše`)
};

const bg_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обърни всички`)
};

const ru_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перевернуть всё`)
};

const uk_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перегорнути всі`)
};

const ar_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قلب الكل`)
};

const hi_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी पलटें`)
};

const th_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พลิกทั้งหมด`)
};

const ja_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて反転`)
};

const zh_cn2_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部翻转`)
};

const zh_hant1_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部翻轉`)
};

const ko_offerdetail_achievements_flipall2 = /** @type {(inputs: Offerdetail_Achievements_Flipall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모두 뒤집기`)
};

/**
* | output |
* | --- |
* | "Flip All" |
*
* @param {Offerdetail_Achievements_Flipall2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_achievements_flipall2 = /** @type {((inputs?: Offerdetail_Achievements_Flipall2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Achievements_Flipall2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_achievements_flipall2(inputs)
	if (locale === "ms") return ms_offerdetail_achievements_flipall2(inputs)
	if (locale === "da") return da_offerdetail_achievements_flipall2(inputs)
	if (locale === "de") return de_offerdetail_achievements_flipall2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_achievements_flipall2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_achievements_flipall2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_achievements_flipall2(inputs)
	if (locale === "fil") return fil_offerdetail_achievements_flipall2(inputs)
	if (locale === "fr") return fr_offerdetail_achievements_flipall2(inputs)
	if (locale === "it") return it_offerdetail_achievements_flipall2(inputs)
	if (locale === "hu") return hu_offerdetail_achievements_flipall2(inputs)
	if (locale === "nl") return nl_offerdetail_achievements_flipall2(inputs)
	if (locale === "no") return no_offerdetail_achievements_flipall2(inputs)
	if (locale === "pl") return pl_offerdetail_achievements_flipall2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_achievements_flipall2(inputs)
	if (locale === "pt") return pt_offerdetail_achievements_flipall2(inputs)
	if (locale === "ro") return ro_offerdetail_achievements_flipall2(inputs)
	if (locale === "fi") return fi_offerdetail_achievements_flipall2(inputs)
	if (locale === "sv") return sv_offerdetail_achievements_flipall2(inputs)
	if (locale === "vi") return vi_offerdetail_achievements_flipall2(inputs)
	if (locale === "tr") return tr_offerdetail_achievements_flipall2(inputs)
	if (locale === "cs") return cs_offerdetail_achievements_flipall2(inputs)
	if (locale === "bg") return bg_offerdetail_achievements_flipall2(inputs)
	if (locale === "ru") return ru_offerdetail_achievements_flipall2(inputs)
	if (locale === "uk") return uk_offerdetail_achievements_flipall2(inputs)
	if (locale === "ar") return ar_offerdetail_achievements_flipall2(inputs)
	if (locale === "hi") return hi_offerdetail_achievements_flipall2(inputs)
	if (locale === "th") return th_offerdetail_achievements_flipall2(inputs)
	if (locale === "ja") return ja_offerdetail_achievements_flipall2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_achievements_flipall2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_achievements_flipall2(inputs)
	return ko_offerdetail_achievements_flipall2(inputs)
});
export { offerdetail_achievements_flipall2 as "offerDetail.achievements.flipAll" }